<template>
<div>
  <h3 class="font-weight-bold">Dados pessoais</h3>

  <table class="table custom-width table-borderless">
    <tbody>
      <tr v-if="idCheck">
        <th scope="row">Nome <span class="font-weight-light">(SEPRO)</span></th>
        <td>
          <p class="font-weight-bold">{{ idCheck.reason.name.status + ' (' + idCheck.reason.name.reason + ')' }}</p>
          <div class="progress">
            <b-progress :value="idCheck.reason.name.similarity * 100" variant="primary" striped class="mb-2"></b-progress>
          </div>
          <!-- <p class="text-danger font-weight-bold">ERRO (similaridade menor que 50%)</p>
          <div class="progress">
            <div class="progress-bar bg-danger" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
          </div> -->
        </td>
      </tr>
      <tr>
        <th scope="row">Nome <span class="font-weight-light">(Checkout)</span></th>
        <td>
          <p class="font-weight-bold">{{ transaction.buyerName }}</p>
        </td>
      </tr>
      <tr>
        <th scope="row">Nome <span class="font-weight-light">(E-commerce)</span></th>
        <td><p class="font-weight-bold">{{ user.name }}</p></td>
      </tr>
      <tr v-if="backCheck">
        <th scope="row">Nome <span class="font-weight-light">(SPC)</span></th>
        <td>
          <p class="font-weight-bold">{{ backCheck.reason.spc_check ? backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['nome'] : (backCheck.reason.grade.reason.debug['spc-serasa'] ? backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['nome'] : '') }}</p>
        </td>
      </tr>
      <tr>
        <th scope="row">Nome <span class="font-weight-light">({{ facebook.network }})</span></th>
        <td><p class="font-weight-bold">{{ facebook.name }}</p></td>
      </tr>
      <tr>
        <th scope="row">Telefone</th>
        <td>
          <div v-for="phone in phones" v-bind:key="phone.id">
            <p class="font-weight-bold">{{ phone.phoneNumber }}</p>
          </div>
        </td>
      </tr>
      <tr>
        <th scope="row">Email</th>
        <td>
          <div v-for="email in emails" v-bind:key="email.id">
            <p class="font-weight-bold">{{ email.email }}</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <h3 class="font-weight-bold">Endereço de entrega</h3>

  <table class="table custom-width table-borderless">
    <tbody>
      <tr>
        <td>Rua, número</td>
        <td><strong>{{ shipping.address.street + ', ' + shipping.address.number }}</strong></td>
      </tr>
      <tr>
        <td>Complemento/Bairro</td>
        <td>{{ shipping.address.complement + ' - ' + shipping.address.district }}</td>
      </tr>
      <tr>
        <td>CEP/Cidade/UF</td>
        <td><strong>{{ shipping.address.zip + ' - ' + shipping.address.city + ' (' + shipping.address.state + ')' }}</strong></td>
      </tr>
    </tbody>
  </table>

  <h3
   v-if="backCheck && ((backCheck.reason.spc_check && backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']) || (backCheck.reason.grade.reason.debug['spc-serasa'] && backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']))"
   class="font-weight-bold">Endereço (SPC)
  </h3>

  <table
    v-if="backCheck && ((backCheck.reason.spc_check && backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']) || (backCheck.reason.grade.reason.debug['spc-serasa'] && backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']))"
    class="table custom-width table-borderless"
  >
    <tbody>
      <tr>
        <td>Rua, número</td>
        <td><strong>{{ backCheck.reason.spc_check ? backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']['logradouro'] + ', ' + backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']['numero'] : (backCheck.reason.grade.reason.debug['spc-serasa'] ? backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']['logradouro'] + ', ' + backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']['numero'] : '') }}</strong></td>
      </tr>
      <tr>
        <td>Complemento/Bairro</td>
        <td>{{ backCheck.reason.spc_check ? backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']['complemento'] + ' - ' + backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']['bairro'] : (backCheck.reason.grade.reason.debug['spc-serasa'] ? backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']['complemento'] + ' - ' + backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']['bairro'] : '') }}</td>
      </tr>
      <tr>
        <td>CEP/Cidade/UF</td>
        <td><strong>{{ backCheck.reason.spc_check ? backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']['cep'] + ' - ' + backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']['cidade']['nome'] + ' - ' + backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']['cidade']['estado']['sigla-uf'] : (backCheck.reason.grade.reason.debug['spc-serasa'] ? backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']['cep'] + ' - ' + backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']['cidade']['nome'] + ' - ' +  backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']['cidade']['estado']['sigla-uf'] : '') }}</strong></td>
      </tr>
    </tbody>
  </table>
</div>
</template>
<script>

export default {
  components: {
  },
  data () {
    return {
      phones: [],
      emails: []
    }
  },
  props: ['user', 'backCheck', 'idCheck', 'faceCheck', 'validation', 'facebook', 'transaction', 'shipping', 'reference', 'tx'],
  methods: {
    loadPhones () {
      this.$http.get('api/validations/' + this.$route.params.txid + '/phones')
        .then(function (res) {
          this.phones = res.data.list
          this.phones = this.phones.sort(function (a, b) {
            return (a.defaultPhoneNumber === b.defaultPhoneNumber) ? 0 : a.defaultPhoneNumber ? -1 : 1
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    loadEmails () {
      this.$http.get('api/validations/' + this.$route.params.txid + '/emails')
        .then(function (res) {
          this.emails = res.data.list
          this.emails = this.emails.sort(function (a, b) {
            return (a.defaultEmail === b.defaultEmail) ? 0 : a.defaultEmail ? -1 : 1
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    }
  },
  mounted () {
    this.$root.$on('loadphone', () => {
      this.loadPhones()
    })
    this.loadPhones()
    this.loadEmails()
  },
  watch: {
    'backCheck' () {
    },
    '$route.params.txid' () {
      this.loadPhones()
      this.loadEmails()
    }
  }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/partial/cards/verification/PersonalData.vue